module.exports = __webpack_public_path__ + "img/top_popularity-three.bcbd51eb.png";